import { Suspense } from 'react'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent } from '@/components/ui/card'
import { Estimation } from '@/routes/databases/create-database/form/sections/overview/estimation'
import { OverviewFallback } from '@/routes/databases/create-database/form/sections/overview/fallback'

export const Overview = () => {
  return (
    <Card className="hidden lg:block">
      <CardContent>
        <div className="flex flex-col gap-4">
          <H3>Overview</H3>
          <div className="flex flex-col gap-6">
            <Suspense fallback={<OverviewFallback />}>
              <Estimation />
            </Suspense>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
